import { css } from '@lastbrand/web-ui-styled-system/css'

// DS twin of legacy `product-custom-banner-message.module.scss` (byte-identical to the offer box) —
// bakes the resolved GreyBoxes cascade: desktop margin 2.3rem bottom; mobile 1.6rem/2.4rem margin +
// 2rem/1.6rem padding. 1.3rem/1.9rem maps to body-14, matching the sibling DS grey boxes.
export const customBannerMessageDsClass = css({
  width: 'full',
  textAlign: 'left',
  padding: 'space-20',
  // NO-TOKEN: legacy 2.3rem (23px) is off the space-* grid.
  marginBottom: '23px',
  backgroundColor: 'paperwhite',
  textStyle: 'body-14',
  display: 'flex',
  flexDirection: 'column',
  '& a': { textDecoration: 'underline' },
  '& .strikeout': { textDecoration: 'line-through' },
  lgDown: {
    width: 'full',
    marginTop: 'space-16',
    marginBottom: 'space-24',
    paddingBlock: 'space-20',
    paddingInline: 'space-16',
  },
})
